const ConfirmBtnAccCreation = ({
  type,
  status,
  isIFSCValid,
  isBankError,
  isButtonDisabled,
  isGSTLoading,
  GSTStatus,
  lookupNext,
  nextButtonEnabled,
  handleClick,
}) => {
  const isPan = type === "pan";
  const show = isPan ? status : status && isIFSCValid && !isBankError;

  const buttonStyles = isPan
    ? {
        color: "var(--text-primary)",
        opacity: isButtonDisabled
          ? "var(--light-opacity)"
          : "var(--base-opacity)",
        borderRadius: "var(--border-radius-sm)",
        cursor: !isButtonDisabled ? "pointer" : "default",
      }
    : {
        color: "var(--text-primary)",
        borderRadius: "var(--border-radius-sm)",
        opacity: isButtonDisabled
          ? "var(--light-opacity)"
          : "var(--base-opacity)",
        cursor: !isButtonDisabled ? "pointer" : "not-allowed",
      };

  return show ? (
    <div className="flex gap-gap-md justify-between items-center w-full rounded-border-radius-md bg-primary-card mb-margin-md py-padding-sm pr-padding-sm pl-padding-md">
      <div className="flex flex-col gap-gap-xs">
        <div className="w-full h-auto font-semibold text-base text-text-primary">
          Confirm to continue account creation
        </div>
        <div className="w-full h-auto font-normal text-xs text-text-secondary">
          {isPan
            ? "Confirm and click next to proceed. Note that creating a new account adds it to the active accounts for the provided PAN."
            : "Confirm and click next to proceed. Creating a new account will transform this account into a joint account and adds it to the active accounts for the provided bank details."}
        </div>
      </div>
      <div
        className={`flex gap-gap-xs
          ${
            isButtonDisabled
              ? "bank_new_create_btn_disabled"
              : `bank_new_create_btn relative z-z-index-base ${(lookupNext && (GSTStatus == null || GSTStatus)) || lookupNext ? "bg-positive-bg global-hover-black" : "bg-primary-nav-act global-hover-white"}`
          }`}
        style={buttonStyles}
        disabled={
          isPan
            ? isGSTLoading
              ? true
              : !GSTStatus && GSTStatus != null
                ? true
                : isButtonDisabled
            : false
        }
        onClick={handleClick}
      >
        <div className="flex items-center">
          <img
            src={
              isPan
                ? lookupNext && (GSTStatus == null || GSTStatus)
                  ? "https://q2pay.in/new_assets/common/approval/selected_with_green_circle.svg"
                  : "https://q2pay.in/new_assets/common/view_all/not_selected_with_grey_circle.svg"
                : nextButtonEnabled
                  ? "https://q2pay.in/new_assets/common/view_all/not_selected_with_grey_circle.svg"
                  : "https://q2pay.in/new_assets/common/approval/selected_with_green_circle.svg"
            }
            alt="btn-icon"
            className="h-icon-sm w-icon-sm flex-shrink-0"
          />
        </div>
        <div
          className={`flex items-center font-normal text-xs text-text-primary`}
        >
          Confirm
        </div>
      </div>
    </div>
  ) : null;
};

export default ConfirmBtnAccCreation;
